import {notifyEndpointUrl} from '../notify-url'
import {useMutation, UseMutationOptions} from '@tanstack/react-query'

export type SubscribePayload = {
  notifyServiceHost: string
  action: 'subscribe'
  email: string
  accountId: string
  notifyOwnedDocChange: boolean
  notifySiteDiscussions: boolean
}

async function subscribeToNotifications({notifyServiceHost, ...payload}: SubscribePayload): Promise<void> {
  const response = await fetch(notifyEndpointUrl(notifyServiceHost, 'public-subscribe'), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  })

  if (!response.ok) {
    const errorData = await response.json()
    throw new Error(errorData.error || 'Failed to subscribe')
  }
}

export function useSubscribeToNotifications(opts?: UseMutationOptions<void, Error, SubscribePayload>) {
  return useMutation({
    mutationFn: subscribeToNotifications,
    ...opts,
  })
}
